export class SecuritiesPropetyFilterToReport {
  block: boolean;
  titlePropertyType: number[];
  active?: boolean;
  inUse?: boolean;
  showDependents?: boolean;
  orderName?: boolean;

  constructor() {
    this.block = null;
    this.titlePropertyType = [];
    this.active = null;
    this.inUse = null;
    this.showDependents = true;
    this.orderName = true;
  }
}
